import { useState } from 'react';

import type { FileDownload } from '@solar/api-client';
import { ApiError } from '@solar/api-client';

/** 받은 blob 을 브라우저 저장으로 넘긴다. 파일명은 서버 Content-Disposition 우선. */
function saveFile({ blob, filename }: FileDownload, fallback: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? fallback;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/**
 * 엑셀 다운로드 버튼 — 레거시 btnType=download/payment 폼 제출 대체.
 *
 * 역할별 노출은 각 화면이 결정하고(서버 403 조건과 동일하게), 여기서는
 * 받기 → 저장 → 실패 메시지 표시만 담당한다.
 */
export function ExcelButton({
  label,
  fallback,
  fetcher,
}: {
  label: string;
  /** 서버가 파일명을 안 내려줄 때 쓸 이름. */
  fallback: string;
  fetcher: () => Promise<FileDownload>;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run() {
    setBusy(true);
    setError(null);
    try {
      saveFile(await fetcher(), fallback);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : '다운로드에 실패했습니다.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <button type="button" className="excel" disabled={busy} onClick={() => void run()}>
        {busy ? '내려받는 중…' : label}
      </button>
      {error !== null && <span className="error">{error}</span>}
    </>
  );
}
